import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

/**
 * Datepicker/Calendar components
 */
export default function Calendar() {
  const [date, changeDate] = useState(new Date());

  return (
    <div>
      {/* Add a style tag to handle the MUI override that was previously in the emotion styled component */}
      <style>
        {`
          .MuiTypography-root {
            font-size: 14px !important;
          }
        `}
      </style>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          autoOk
          orientation="landscape"
          variant="static"
          disableToolbar={true}
          openTo="date"
          value={date}
          onChange={changeDate}
          style={{ margin: "0 auto" }}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
}
